
/// <amd-module name="TFS/Token/PatTokenPage/Context/TelemetryContext" />
import * as React from 'react';
import { IPatPageContextValue, PatPageConsumer } from 'Context/PatPageContext';
import { IVssPageContext } from 'VSS/Platform/Context';
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { TokenActionCreator, TokenFilter } from 'Actions/TokenActionCreator';
import { PatPageKeys, PersonalAccessTokenPage, PatPageTelemetry } from 'Constants/TokenConstants';
import { PanelActionCreator, PanelOperationType } from 'Actions/PanelActionCreator';
import { DisplayFilterOptions } from 'Contracts/Token';

export interface ITelemetryContextProps {
}

export interface ITelemetryContextInternalProps extends ITelemetryContextProps {
    pageContext: IVssPageContext;
    tokenAction: TokenActionCreator;
    panelAction: PanelActionCreator;
}

export class TelemetryContextInternal extends React.Component<ITelemetryContextInternalProps> {
    constructor(props: ITelemetryContextInternalProps) {
        super(props);

        this.addAllListeners(props);
    }

    private telemetryService = this.props.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");

    public componentDidMount(): void {

        this.telemetryService.publishEvent(
            PersonalAccessTokenPage,
            PatPageTelemetry.PatPageView,
            {}
        )
    }

    public render() {
        return null;
    }

    private addAllListeners = (newProps: ITelemetryContextInternalProps) => {
        const { addedToken, revokedToken, updatedToken, recievedNewPageOfTokens, finishedTokenFetch } = newProps.tokenAction.dispatchers;
        const { tokenPanelOpened } = newProps.panelAction.dispatchers;

        addedToken.addListener((payload) => {
            const telemetryData = {
                [PatPageKeys.userId]: payload.token.userId,
                [PatPageKeys.scope]: payload.token.scope,
                [PatPageKeys.authorizationId]: payload.token.authorizationId,
                [PatPageKeys.tokenValidTo]: payload.token.validTo,
                [PatPageKeys.isTokenValid]: payload.token.isValid
            }

            this.telemetryService.publishEvent(
                PersonalAccessTokenPage,
                PatPageTelemetry.PatPageAddToken,
                telemetryData
            );
        });

        revokedToken.addListener((payload) => {
            const telemetryData = {
                [PatPageKeys.authorizationId]: payload.authorizationId,
            }

            this.telemetryService.publishEvent(
                PersonalAccessTokenPage,
                PatPageTelemetry.PatPageRevokeToken,
                telemetryData
            );
        });

        updatedToken.addListener((payload) => {
            const telemetryData = {
                [PatPageKeys.userId]: payload.token.userId,
                [PatPageKeys.scope]: payload.token.scope,
                [PatPageKeys.authorizationId]: payload.token.authorizationId,
                [PatPageKeys.tokenValidTo]: payload.token.validTo,
                [PatPageKeys.isTokenValid]: payload.token.isValid
            }

            this.telemetryService.publishEvent(
                PersonalAccessTokenPage,
                PatPageTelemetry.PatPageUpdateToken,
                telemetryData
            );
        });

        recievedNewPageOfTokens.addListener((payload) => {
            const telemetryData = {
                [PatPageKeys.fetchVersion]: payload.fetchVersion,
                [PatPageKeys.currentRow]: payload.nextRowNumber
            }

            this.telemetryService.publishEvent(
                PersonalAccessTokenPage,
                PatPageTelemetry.PatPageLoadedMoreTokensOnClick,
                telemetryData
            );
        });

        tokenPanelOpened.addListener((payload) => {
            const telemetryData = {
                [PatPageKeys.panelType]: this.convertPanelOperationTypeToString(payload.operation)
            }

            this.telemetryService.publishEvent(
                PersonalAccessTokenPage,
                PatPageTelemetry.PatPagePanelOpened,
                telemetryData
            );
        });

        finishedTokenFetch.addListener((payload) => {
            const telemetryData = {
                [PatPageKeys.filterType]: this.convertDisplayFilterOptionsToString(payload.filter),
                [PatPageKeys.fetchVersion]: payload.fetchVersion,
                [PatPageKeys.nextRowNumber]: payload.nextRowNumber
            }

            this.telemetryService.publishEvent(
                PersonalAccessTokenPage,
                PatPageTelemetry.PatPageResetTokens,
                telemetryData
            );
        });
    }

    private convertPanelOperationTypeToString = (panelOperation: PanelOperationType): string => {
        if (panelOperation === PanelOperationType.Add) {
            return "Add";
        }
        if (panelOperation === PanelOperationType.Edit) {
            return "Edit";
        }
        if (panelOperation === PanelOperationType.Success) {
            return "Success";
        }
        if (panelOperation === PanelOperationType.ConfirmRevoke) {
            return "Confirm Revoke";
        }
        else {
            return "Confirm Regenerate";
        }
    }

    private convertDisplayFilterOptionsToString = (filter: TokenFilter): string => {
        if (filter.status === DisplayFilterOptions.Active) {
            return `Status: Active, Organization: ${filter.organization?.name}`;
        }
        if (filter.status === DisplayFilterOptions.Revoked) {
            return `Status: Revoked, Organization: ${filter.organization?.name}`;
        }
        if (filter.status === DisplayFilterOptions.Expired) {
            return `Status: Expired, Organization: ${filter.organization?.name}`;
        }
        else {
            return `Status: All, Organization: ${filter.organization?.name}`;
        }
    }
}

export const TelemetryContext = (props: ITelemetryContextProps) => {
    return(
        <PatPageConsumer>
            {(patPageContext: IPatPageContextValue) =>
                <TelemetryContextInternal
                    {...props}
                    pageContext={patPageContext.pageContext}
                    tokenAction={TokenActionCreator.getInstance(patPageContext.pageContext)}
                    panelAction={PanelActionCreator.getInstance()}
                />
            }
        </PatPageConsumer>
    )
}
